export default __webpack_public_path__ + "static/media/insulin-night-icon.f43767f2.svg";